module.exports = __webpack_public_path__ + "static/media/dpd.ebd730fe.png";